export default {
	start: {
		title: "AI-plattform",
		tips: "Tjäna pengar på att scrolla! Dagligt uttag med ett klick – Din telefon är en pengamaskin!"
	},
	login: {
		tips: "Har du inget konto?",
		Signup: "Registrera dig",
		logIn: "Logga in",
		Remember: "Kom ihåg mig",
		form: {
			label: ["Användarnamn/Telefon", "Lösenord"]
		},
		forgotPassword: "Glömt lösenord?",
		contactSupport: "Kontakta supporten",
		title: "Skapa konto",
		content: ["Behöver du ett konto?", "Skapa ett här"]
	},
	register: {
		form: {
			label: [
				"Användarnamn",
				"Telefonnummer",
				"Transaktionslösenord",
				"Inloggningslösenord",
				"Bekräfta inloggningslösenord",
				"Kön",
				"Inbjudningskod",
				"E-post",
				"Verifieringskod"
			],
			rule: {
				Username: "Användarnamnet måste vara 4–10 tecken",
				Email: "Ange en giltig e-postadress",
				Phone: "Telefonnumret måste vara minst 4 siffror",
				ConfirmLoginPassword: "Lösenorden matchar inte",
				TradingPassword: "Transaktionslösenordet måste vara minst 6 tecken",
				LoginPassword: "Inloggningslösenordet måste vara minst 6 tecken"
			}
		},
		sendMsg: "Kod skickad! Kontrollera ditt meddelande.",
		agree: ["Jag godkänner {0}", "Sekretesspolicy, MSA", "och", "Användarvillkor"],
		content: [
			"Skapa ett gratis konto",
			"Har du redan ett konto?",
			"Logga in här",
			"Skapa konto",
			"Genom att fortsätta godkänner du våra"
		]
	}
};
